// To do:
// - Move tab definitions to own components
// 

import React, { useState } from 'react';
import { Paragraph, Tab, Tabs, Box, Text, TextInput, Image } from 'grommet';
import { PageHeader, Page, PageContent, Heading } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { ValueStreamsGrid } from '../valuestreams/ValueStreamsGrid';
import './page.css';

const searchSuggestions = [
    'Sales & Marketing', 'Source, Make & Deliver', 'Billing & Accounting', 'Support & Retention',
    'CPQ', 'Integration Fabric', 'Data Platform', 'SAP', 'SAP S/4', 'SAP BRIM', 'SAP Commerce',
    'SAP Ariba', 'SAP GTS', 'Salesforce Sales Cloud', 'Salesforce Service Cloud', 'Testing Automation',
    'Hybrid Cloud', 'Infrastructure', 'Data & AI', 'Supply Chain',
];

export const RoadmapsHome = () => {
    const [isFocused, setIsFocused] = useState(false);
    const [activeProductTab, setActiveProductTab] = useState(0);
    const [activePlatformTab, setActivePlatformTab] = useState(0);
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState(searchSuggestions.slice(0, 5));

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    const filterResults = query => {
        const regexp = new RegExp(query, 'i');
        return query ? searchSuggestions.filter(option => regexp.test(option)) : searchSuggestions;
    };

    const onChange = event => {
        const nextValue = event.target.value;
        setValue(nextValue);
        setSuggestions(filterResults(nextValue).slice(0, 5));
    };

    const onSuggestionSelect = () => {
        window.location.href = '/roadmap-display'; // Temp...
    };

    return (
        <Page flex="grow" background="background-back">
            <Box background="url('images/space-background.png')" height="200px">
                <Box margin={{ top: 'none', left: 'large' }}>
                    <PageHeader 
                        pad={{ top: '15px', bottom: '15px' }}
                        title={<Text color="white" size="xxlarge" weight="bolder">Welcome to HPE's Internal Road Map Explorer</Text>}
                        subtitle="Innovation and transformation journey insights."
                        size="medium"
                        style={{ color: 'white' }}
                    />
                    <TextInput
                        className="custom-placeholder"
                        aria-label="search"
                        placeholder={<Text color="white">Display by value stream, capability, etc.</Text>}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        style={{ borderColor: isFocused ? 'black' : 'white', color: 'white' }}
                        reverse
                        suggestions={suggestions}
                        onSuggestionSelect={onSuggestionSelect}
                        value={value}
                        onChange={onChange}
                        type="search"
                        width="medium"
                        margin={{ bottom: '15px' }}
                    />
                </Box>
            </Box>

            <PageContent flex="grow" background="background-back" width="80%">
                <ValueStreamsGrid isVerticalGrid={true} isGridExpanded={false} />
                
                <Heading size="medium" margin={{ top: 'large' }}>Explore by <b>Product</b></Heading>
                <Tabs activeIndex={activeProductTab} onActive={setActiveProductTab} justify="start">
                    <Tab title="eCommerce">
                        <MapTabContent>
                            <Paragraph margin="none">eCommerce top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="SaaS">
                        <MapTabContent>
                            <Text size="small" margin="none">Temp illustrative placeholder:</Text>
                            <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                                <Image fit="cover" src="images/example-saas-product-view.png" />
                            </Box>
                        </MapTabContent>
                    </Tab>
                    <Tab title="IaaS">
                        <MapTabContent>
                            <Paragraph margin="none">IaaS top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="CAPEX">
                        <MapTabContent>
                            <Paragraph margin="none">CAPEX top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Lease">
                        <MapTabContent>
                            <Paragraph margin="none">Lease top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Asset Management">
                        <MapTabContent>
                            <Paragraph margin="none">Asset Management top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="ChatHPE">
                        <MapTabContent>
                            <Paragraph margin="none">ChatHPE top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                </Tabs>

                <Heading size="medium" margin={{ top: 'large' }}>Explore by major <b>Platform</b></Heading>
                <Tabs activeIndex={activePlatformTab} onActive={setActivePlatformTab} justify="start">
                    <Tab title="IT Hybrid Cloud">
                        <MapTabContent>
                            <Paragraph margin="none">IT's hybrid cloud top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Data & AI">
                        <MapTabContent>
                            <Paragraph margin="none">Data & AI top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Salesforce">
                        <MapTabContent>
                            <Paragraph margin="none">Salesforce top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="SAP">
                        <MapTabContent>
                            <Paragraph margin="none">SAP top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Integration Fabric">
                        <MapTabContent>
                            <Paragraph margin="none">Integration Fabric roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Testing Automation">
                        <MapTabContent>
                            <Paragraph margin="none">Testing Automation top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                    <Tab title="Dev Tooling">
                        <MapTabContent>
                            <Paragraph margin="none">Dev tooling top roadmap priorities coming soon!</Paragraph>
                        </MapTabContent>
                    </Tab>
                </Tabs>
            </PageContent>
        </Page>
    );
};


